import { IS_LOCAL_ENV } from "../App";
import { _axios } from "./config";
import qs from "qs";

export const getProductClasses = async (depth, limit) => {
  try {
    const { data } = await _axios.get(`/api/productClasses?limit=0${depth ? "&depth=" + depth : ""}${limit ? "&limit=0" : ""}`);
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const getProductClass = async (productClassId) => {
  try {
    const { data } = await _axios.get(`/api/productClasses/${productClassId}?depth=2`);
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const getProductSubClasses = async (productClassId) => {
  try {
    const { data } = await _axios.get(`/api/productSubClasses?where[class][equals]=${productClassId}`);
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const getAllSubClasses = async () => {
  try {
    const { data } = await _axios.get(`/api/productSubClasses?limit=0`);
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}


export const createProductClass = async (props) => {
  try {
    IS_LOCAL_ENV && console.log("creando productClass");
    const { data } = await _axios.post(`/api/productClasses`, props);
    return data.doc;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const updateProductClass = async (productClassId, updatedProps) => {
  try {
    IS_LOCAL_ENV && console.log("actualizando productClass");
    const { data } = await _axios.patch(`/api/productClasses/${productClassId}`, { ...updatedProps });
    return data.doc;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const deleteProductClassImage = async (imageId) => {
  try {
    const { data } = await _axios.delete(`/api/productClassPhotos/${imageId}`);
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const uploadProductClassImage = async (props) => {
  try {
    const formData = new FormData();
    formData.append("alt", props.alt);
    formData.append("file", props.file);

    const { data } = await _axios.post(`/api/productClassPhotos`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    });
    return data.doc;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

//===================== sub classes ========================

export const createProductSubClass = async (props) => {
  try {
    IS_LOCAL_ENV && console.log("creando productClass");
    const { data } = await _axios.post(`/api/productSubClasses`, props);
    return data.doc;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const updateProductSubClass = async (productClassId, updatedProps) => {
  try {
    IS_LOCAL_ENV && console.log("actualizando productClass");
    const { data } = await _axios.patch(`/api/productSubClasses/${productClassId}`, { ...updatedProps });
    return data.doc;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

//testear
export const deleteProductSubClass = async (productClassId) => {
  try {
    const { data } = await _axios.delete(`/api/productSubClasses/${productClassId}`);
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const relateClassToSubClass = async (classId, subClassId) => {
  try {

    const { data: classData } = await _axios.get(`/api/productClass/${classId}`);

    if (!classData) {
      throw new Error(`Clase con ID ${classId} no encontrada.`);
    }

    const existingSubClasses = classData.subClasses || []; // Asegurar que el array exista
    const updatedSubClasses = [...new Set([...existingSubClasses, subClassId])]; // Evitar duplicados

    // Actualizar la clase con el nuevo array de relaciones
    const { data: updatedClass } = await _axios.patch(`/api/productClass/${classId}`, {
      subClasses: updatedSubClasses,
    });

    return updatedClass;
  } catch (err) {
    if (IS_LOCAL_ENV) console.error(err);
    throw err; // Lanza el error para que pueda ser manejado por quien llame al servicio
  }
};

export const deleteProductSubClassImage = async (imageId) => {
  try {
    const { data } = await _axios.delete(`/api/productSubClassPhotos/${imageId}`);
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const uploadProductSubClassImage = async (props) => {
  try {
    const formData = new FormData();
    formData.append("alt", props.alt);
    formData.append("file", props.file);

    const { data } = await _axios.post(`/api/productSubClassPhotos`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    });
    return data.doc;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}
